export default __webpack_public_path__ + "dcdd6dba67f85c644cc081068b0d4b4b.svg";